import React, { useEffect, useRef } from "react";
import ApexCharts from "apexcharts";
import "./reports.css";
import ReactApexChart from "react-apexcharts";

const RegisteredGamesChart = ({ registeredGames }) => {
  const radialRef = useRef(null);
  useEffect(() => {
    if (registeredGames?.length > 0) {
      window.Apex = {
        chart: { foreColor: "#ccc", toolbar: { show: false } },
        stroke: { width: 3 },
        dataLabels: { enabled: false },
        tooltip: { theme: "dark" },
        grid: { borderColor: "#535A6C", xaxis: { lines: { show: true } } },
      };

      const mountChart = (ref, options) => {
        const el = ref.current;
        if (el) {
          const chart = new ApexCharts(el, options);
          chart.render();
        }
      };

      const totalCount = registeredGames.reduce(
        (sum, game) => sum + game.count,
        0
      );
      const types = registeredGames?.map(
        (m) => m.category?.toString() || "Unknown"
      );
      const counts = registeredGames?.map((m) =>
        Math.floor((m.count / totalCount) * 100)
      );
      const optionsCircle4 = {
        chart: {
          type: "radialBar",
          height: 350,
          // Remove fixed width
          width: "100%", // or omit entirely
        },
        plotOptions: {
          radialBar: {
            inverseOrder: true,
            hollow: {
              margin: 5,
              size: "48%",
              background: "transparent",
            },
            track: {
              show: false,
            },
            startAngle: -180,
            endAngle: 180,
          },
        },
        stroke: {
          lineCap: "round",
        },
        // series: [50, 70, 80],
        // labels: ["Action", "Sport", "Racing"],
        series: counts,
        labels: types,
        legend: {
          show: true,
          floating: true,
          position: "right",
          offsetX: 70,
          offsetY: 230,
        },
        legend: {
          show: true,
          floating: true,
          position: "right",
          offsetX: 70,
          offsetY: 230,
        },
      };

      mountChart(radialRef, optionsCircle4);
    }
  }, [registeredGames]);
  return (
    <div className="col-md-4 col-sm-6 d-flex justify-content-center">
      <div className="box shadow p-4 rounded cardBox text-light w-100 d-flex flex-column">
        <h5 className="text-center fw-bold mb-3">Total Registered Games</h5>
        <div className="d-flex justify-content-center align-items-center flex-grow-1">
          <div
            id="radialBarBottom"
            ref={radialRef}
            className="w-100"
            style={{ maxWidth: "100%", overflow: "hidden" }}
          />
        </div>
      </div>
    </div>
  );
};

export default RegisteredGamesChart;
